import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './EmptySearchResults.styles';

export const EmptySearchResults = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <S.Title>{t('pages.ads.no_matching_ads_title')}</S.Title>
      <S.SubTitle>{t('pages.ads.no_matching_ads_subtitle')}</S.SubTitle>
    </S.Box>
  );
};
